export enum MessageTypes {
    SMS = 1,
    File = 2,
    Voice = 3,
    Image = 4,
    Video = 5,
    Location = 6,
    Template = 7,
}
